import React from 'react';
import Node, {
  NodeProps,
} from 'components/canvas/components/nodes/components/base-node';
import NodeHeader from 'components/canvas/components/nodes/components/base-node/components/node-header';
import NodeSnapshot from 'components/canvas/components/nodes/components/node-snapshot';
import NodeContextMenu from 'components/canvas/components/nodes/components/base-node/components/node-context-menu';
import GlobalLinksIndicator from 'components/canvas/components/nodes/components/base-node/components/global-links-indicator';
import useNodeDimensionsOperations from 'components/canvas/hooks/use-node-dimensions-operations';
import { SurfaceBackgroundNode } from 'graphql/types';
import Nodes from '../..';
import { CutIcon } from '../base-node/components/node-context-menu/style';
import LockIcon from './components/lock-icon';
import IncreaseIcon from './components/increase-icon';
import DecreaseIcon from './components/decrease-icon';
import DeleteIcon from '../base-node/components/node-context-menu/components/delete-icon';
import { Text } from 'react-konva';

interface BackgroundNodeProps extends NodeProps {}

function BackgroundNode(props: BackgroundNodeProps) {
  const { node, showNodeModal } = props;
  const x = node as SurfaceBackgroundNode;

  const { getNodeDimensionsByType } = useNodeDimensionsOperations();
  const click = () => {
    console.warn('XXXXX click', node);
    //   const x = node as SurfaceBackgroundNode
    if (!x.isFixed) {
      showNodeModal(node);
    }
  };

  function iconsRenderer({ icons }): React.ReactElement[] | null {
    const ownerIcons = [
      /*  <SurfaceNodeEditIcon onClick={showSurfaceEditForm} />,
      ...(Object.values(icons) as React.ReactElement[]), */
      <LockIcon node={node}></LockIcon>,
    ];

    if (!x.isFixed) {
      ownerIcons.push(<IncreaseIcon node={node}></IncreaseIcon>);

      ownerIcons.push(<DecreaseIcon node={node}></DecreaseIcon>);

      ownerIcons.push(
        <DeleteIcon
          node={node}
          // onAfterDelete={props.onAfterDelete}
          hardDelete={false}
        />,
      );
      ownerIcons.reverse();
    }

    return ownerIcons;
  }
  // const { width, height } = getNodeDimensionsByType(node?.type);
  const width = x.size.width;
  const height = x.size.height; //700
  const hasImage = false;
  console.log('NODE ', node);
  return (
    <Node {...props} width={width} height={height} onClick={click}>
      {({ isSelected }) => {
        return (
          <>
            {/* <NodeHeader
              x={0}
              offsetY={40}
              fill="red"
              fontStyle="bold"
              text={node.name ?? ''}
              width={width - 30}
              isReference={node.isReference}
            /> */}
            {/*  <GlobalLinksIndicator node={node} x={width} /> */}
            {hasImage && (
              <NodeSnapshot
                node={node}
                width={width}
                height={height}
                scale={3.5}
                isSelected={isSelected}
              />
            )}

            {!hasImage && (
              <NodeSnapshot
                node={node}
                width={width}
                height={height}
                scale={3.5}
                isSelected={isSelected}
              />
              // <Text
              //   x={0}
              //   y={0}
              //   text={node.name}
              //   // fontFamily={typography.font.fontFamily}
              //   width={width}
              //   height={height}
              //   fontSize={width / 5}
              //   lineHeight={1.5}
              //   wrap="char"
              // />
            )}

            {/* NodeContextMenu has to be last component in tree because of z index and how react-konva assigns it to elements */}
            {
              <NodeContextMenu
                width={width}
                height={height}
                node={node}
                icons={iconsRenderer}
              />
            }
          </>
        );
      }}
    </Node>
  );
}

export default BackgroundNode;
